import axios from "axios";

const authHeader = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.accessToken;
    if (token) {
      return { Authorization: `Bearer ${token}` };
    }
  } catch (error) {
    console.error('No se pudo obtener la sesion del usuario', error);
  }
  return {};
}

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

http.interceptors.request.use(
  config => {
    const token = authHeader();
    if(token.Authorization){
      config.headers.Authorization = token.Authorization;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
)

// Quien arma la app (el router) registra aqui que hacer ante un 401. Asi este
// modulo no importa router ni store (el router ya depende de servicios que
// importan este archivo) y la sesion se cierra sin recargar la pagina.
let unauthorizedHandler = null;

const onUnauthorized = (handler) => {
  unauthorizedHandler = handler;
}

http.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if(error.response && error.response.status === 401){
      if(unauthorizedHandler){
        unauthorizedHandler(error);
      } else {
        // Sin handler registrado (la app no arranco por el router): lo unico
        // seguro es descartar la sesion y recargar en el login.
        localStorage.removeItem('user');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
)

export { http, authHeader, onUnauthorized }